import React, { ReactNode } from 'react';
import styles from './UspFaqWrapper.module.scss';

interface UspFaqWrapperProps {
    children: ReactNode;
}

export const UspFaqWrapper = ({ children }: UspFaqWrapperProps) => {
    return <div className={styles.uspFaqWrapper}>{children}</div>;
};
